import { createSelector } from 'reselect';

import { LoadStatus, State } from '../../Types';

const propertyTenantResolutionState = ({ propertyTenantResolution }: State) => propertyTenantResolution;

export const propertiesLoadStatus = createSelector(
    propertyTenantResolutionState,
    ({ loadStatus }): LoadStatus => loadStatus,
);

export const propertiesAreLoaded = createSelector(propertiesLoadStatus, (loadStatus) => loadStatus === LoadStatus.LOADED);
export const occupantsAreLoaded = createSelector(propertyTenantResolutionState, ({ loadingOccupants }) => !loadingOccupants);

export const isLoadingOccupants = createSelector(propertyTenantResolutionState, ({ loadingOccupants }) => loadingOccupants);

export const properties = createSelector(
    [propertyTenantResolutionState, isLoadingOccupants],
    ({ loadStatus, sortOrder, ...rest }) => rest,
);

export const propertiesList = createSelector(propertyTenantResolutionState, ({ loadStatus, sortOrder, ...rest }) =>
    Object.values(rest),
);

export const sortedPropertiesList = createSelector(
    propertyTenantResolutionState,
    (propertyTenantResolutionState) =>
        propertyTenantResolutionState.sortOrder?.map((i) => propertyTenantResolutionState[i]) || [],
);

export const property = (propertyId: number | string) =>
    createSelector(
        propertyTenantResolutionState,
        (propertyTenantResolutionState) => propertyTenantResolutionState[propertyId] || {},
    );

export const currentPermissionContext = createSelector(
    propertyTenantResolutionState,
    ({ currentPermissionContext }) => currentPermissionContext,
);

export const propertiesWithOccupantsLoaded = createSelector(
    propertyTenantResolutionState,
    (propertyTenantResolutionState) => propertyTenantResolutionState.propertiesWithOccupantsLoaded,
);
